// angular
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// components
import { FiltersDialogComponent } from '@app/core/components/filters-dialog/filters-dialog.component';
import { ProductsFiltersComponent } from '../../components/products-filters/products-filters.component';
// utils
import { DialogRef } from '@app/core/shared/utils/dialog/dialog-ref';

@Component({
  selector: 'pwj-products-filters-dialog',
  standalone: true,
  imports: [FiltersDialogComponent, ProductsFiltersComponent],
  templateUrl: './products-filters-dialog.component.html',
})
export class ProductsFiltersDialogComponent {
  private readonly _dialogRef = inject(DialogRef);
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);

  close(): void {
    this._dialogRef.close();
  }

  applyFilters(): void {
    this.close();
  }

  removeFilters(): void {
    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: {
        category_type_id: null,
        category_id: null,
        sub_category_id: null,
        take: null,
        skip: null,
      },
      queryParamsHandling: 'merge',
    });
  }
}
